//import React components
import {Button} from "reactstrap";
import {useRef} from "react";

//import components
//import icons
import SideControl from "../../right/SideControl";
import {useDetectOutSideClick} from "../../../../global/callback functions/Triggers/eventListners";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useSettingStore} from "../../../../context/settings";


export default function UserControls() {
  const sideControlRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const toggleUserbar = useSettingStore((state) => state.toggleUserbar);


  useDetectOutSideClick(sideControlRef, buttonRef, (toggle?: boolean) => {
    if (toggle) {
      toggleUserbar();
    } else {
      useSettingStore.setState({userbarExtended: false});
    }
  });


  return (
    <div ref={sideControlRef} className={"nav-dropdown-wrapper"}>
      <Button
        title={"Åpne bruker panel"}
        className={"nav-user"}
        color={"blank"}
        innerRef={buttonRef}
        onClick={toggleUserbar}
      >
        <FontAwesomeIcon icon={["far", "user"]}/>
      </Button>
      <SideControl/>
    </div>
  )
}
